export default {
  title: 'Hoppá! Az oldal nem található!',
  subtitle: 'Elérted a megfigyelhető Sportya univerzum peremét.',
  goHome: 'Menj a Főoldalra',
  contact: 'Tudasd velünk, hogyan jutottál el ide, hogy egy jobb világot (és weboldalt) építhessünk - <1>contact@sportya.net</1>. \nKöszönjük, barátunk!',
};
